import React, { useRef } from 'react';
var VeltTextCommentToolbarCommentAnnotation = function (props) {
    var defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-text-comment-toolbar-comment-annotation", { ref: ref, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltTextCommentToolbarCommentAnnotation;
